import React from 'react'
import { useIntl } from 'react-intl'

import { Button, BUTTON_VARIANT_PRIMARY } from 'mailup-web-components'
import { useRecoilCallback } from 'recoil'
import { fetchSendingsCallback } from '../recoil/callbacks/callbacks'

const UpdateButton = () => {
  const intl = useIntl()
  const fetchSendings = useRecoilCallback(fetchSendingsCallback, [])

  return (
    <>
      <Button kind={BUTTON_VARIANT_PRIMARY} onClick={fetchSendings}>
        {intl.formatMessage({ id: 'Load.MailupCommon.Update' })}
      </Button>
    </>
  )
}

export default UpdateButton
